export const LOGO = "https://customer-assets.emergentagent.com/job_cae47e40-8a93-4199-a6df-339e51d4c85f/artifacts/3vl2w3fj_image.png";
export const FOUNDER = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/dro48x2x_image.png";
export const GROUP = "https://customer-assets.emergentagent.com/job_cae47e40-8a93-4199-a6df-339e51d4c85f/artifacts/bbhfdlmu_image.png";
export const PARTNERS_COLLAGE = "https://customer-assets.emergentagent.com/job_cae47e40-8a93-4199-a6df-339e51d4c85f/artifacts/bdsqd4hp_image.png";
export const UPCOMING = "https://customer-assets.emergentagent.com/job_cae47e40-8a93-4199-a6df-339e51d4c85f/artifacts/ti0sceko_image.png";
export const SEASONAL = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/dlg4wzuw_IMG_2521.png";
export const NONPROFIT_1 = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/ciqmlmq1_image.png";
export const NONPROFIT_2 = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/3isfm8bk_image.png";
export const WOMEN_OWNED = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/thme74wq_IMG_5900.png";
export const PRIVATE_EVENTS = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/vgcctt42_image.png";

// Authentic Flowtastics community photos
export const KIDS_CLASS = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/l4xdiiyz_IMG_2234.png";
export const FLOWER_GROUP = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/p5g1hqpk_Screenshot%202026-05-17%20at%205.07.23%E2%80%AFPM.png";
export const FRENCHIE_GROUP = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/ch76z7i0_Screenshot%202026-05-17%20at%205.09.49%E2%80%AFPM.png";
export const FAMILY_YOGA = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/tfcemuxk_image.png";
export const GALENTINES_GROUP = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/0tt5mf4c_image.png";
export const GALENTINES_SOPHIA = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/jl8m72sz_image.png";
export const BANNER_GROUP = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/2xwr10k5_image.png";
export const ZOOMBA_FLOW = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/mg69trcl_image.png";
export const JIMMYFUND_GROUP = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/h2h3onrj_image.png";

export const HERO_BG = "https://customer-assets.emergentagent.com/job_flowtastics-live/artifacts/a7818f4o_Screenshot%202026-05-17%20at%204.52.34%E2%80%AFPM.png";

export const CONTACT = {
  email: "Flowtasticsevents@gmail.com",
  phone: "(617) 893-4926",
  instagram: "https://instagram.com/flowtastics",
  instagramHandle: "@flowtastics",
  bookingUrl: "https://www.momoyoga.com/flowtastics/teacher-profile",
};

export const BOOKING_URL = "https://www.momoyoga.com/flowtastics/teacher-profile";

export const TESTIMONIALS = [
  {
    quote: "Yoga in Brookline Art Studio with snacks and girlhood — 10/10. If you're near Boston and want to come with me to the next monthly themed yoga class hosted by Flowtastics, lmk! They put on the best lil retreats, it's perfect for my girlies that are post-grad, wanting to make new friends. Ty, Sophia, for my invite.",
    name: "Dr. Connie Wang",
    detail: "Brookline Art Studio Flow",
  },
  {
    quote: "My first outdoor flow — 100/10. Thank you, Sophia, for having me! Snacks, theme, views, the ladies — everything 10/10.",
    name: "Faisa Somali",
    detail: "First Outdoor Flow",
  },
  {
    quote: "I love seeing mindfulness and creativity come together — this is the perfect example of how art and yoga go hand in hand. These moments of connection and balance are so inspiring.",
    name: "Diana Stelin",
    detail: "Diana Stelin Gallery",
  },
  {
    quote: "Thank you Flowtastics — the best teachers and event coordination.",
    name: "Fatima Somali",
    detail: "Flowtastics Community",
  },
  {
    quote: "If you're in the Boston area, follow Flowtastics for all types of events.",
    name: "Asal Heydarpour",
    detail: "Boston",
  },
  {
    quote: "Sophia also holds yoga events and fun outside-studio events with Flowtastics — go check them out.",
    name: "Widya Suraannisa",
    detail: "Flowtastics Community",
  },
  {
    quote: "Beautiful morning with Flowtastics.",
    name: "Jen Chamberlain",
    detail: "Sunrise Flow",
  },
];

export const PARTNERS = [
  { name: "Casall", note: "Performance & lifestyle apparel" },
  { name: "Circus Complex Co.", note: "Aerial studio + nonprofit" },
  { name: "Diana Stelin Gallery", note: "Fine art + studio space" },
  { name: "ETFashion.Co", note: "Women-owned fashion" },
  { name: "Juno", note: "Women-owned yoga studio" },
  { name: "theblankcanvasco", note: "Creative collaboration" },
  { name: "Tree Yoga", note: "Community yoga + wellness" },
  { name: "Zest The Collective", note: "Wellness + community space" },
];

export const NONPROFITS = [
  { name: "Triple C's Dana-Farber Foundation", in_support_of: "The Jimmy Fund", raised: "$750+" },
  { name: "Circus Complex Co. Nonprofit", in_support_of: "Aerial arts access", raised: "$1,050+" },
  { name: "Animal Rescue League of Boston", in_support_of: "Frenchie Flow donations", raised: "$150+" },
  { name: "Blood Cancer United", in_support_of: "Madison's Blood Cancer Fundraising Initiative · Visionaries of the Year campaign", raised: "$150+" },
];
